module.exports = __webpack_public_path__ + "static/media/05.270ac81a.mp3";